import React from "react";

import { Row, Col } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import { PlusOutlined } from "@ant-design/icons";
import { Player } from "video-react";
import videoPoster from "../../Imgs/HomePage/videoPoster.jpg";

// CSS Files
import "../../../../node_modules/video-react/dist/video-react.css";
import "../../Fonts/Fonts.css";
import "../../Statics/Common/FontStyle.css";
import "../../Statics/HomePage/Introduction.css";

import sandoghKhesarat from "../../Imgs/HomePage/Sandogh/1.jpg";
import sandoghKeshavarzi from "../../Imgs/HomePage/Sandogh/2.png";

const SandoghKhesarat = (props) => {
  return props.size === "laptopdesktop" ? (
    <div style={{ backgroundColor: "#ff" }}>
      <Row>
        <Col span={3}></Col>
        <Col span={9}>
          <Margin top={5}></Margin>
          <h5
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              marginTop: "-10px",
              textAlign: "right",
            }}
          >
            <strong>صندوق بیمه حوادث طبیعی ساختمان</strong>
          </h5>
          <Margin top={3}></Margin>
          <p className="textParagraph">
            در راستای ماده ۱ قانون تاسیس صندوق بیمه ساختمان تمام منازل مسکونی
            کشور بالغ بر ۳۲ میلیون انشعاب برق بیمه پایه نزد صندوق هستند که
            خسارتهای مالی ناشی از حوادث طبیعی از جمله زلزله، سیل، طوفان، صاعقه،
            سنگینی برف، رانش زمین، ریزش کوه و دریالرزه (سونامی) به زیاندیده
            هموطنان پرداخت میگردد که در سال اول در دو‌ نوبت، نوبت اول ۲۰ هزار
            ساختمان خسارت دیده ودر نوبت دوم ۴۵ هزار ساختمان توسط ایرانیان پوشش
            در سراسر کشور ارزیابی گردید و بعد از رضایت این دو نوبت خسارت کل کشور
            به این شرکت وفق قرارداد واگذار گردیده است به عبارتی از ابتدا تاسیس
            این صندوق ، ارزیابی از طریق اپلیکیشن کارشناسی و CRM شبانه روزی با
            بهره گیری از گسترده ترین شبکه کارشناسان خبره بیمه های آتش سوزی و
            ساختمان به ايرانيان پوشش در سرتاسر كشور واگذار گرديده است و تاكنون
            به عنوان بازوی امین صندوق حوادث طبیعی ساختمان، در زمینه های مرتبط با
            ارزیابی خسارات ناشی از حوادث طبیعی، نقشی مؤثر و حیاتی را در حمایت از
            زیان دیدگان به منظور صیانت از حقوق آنها ایفا نموده است.
          </p>
          <Margin bottom={3}></Margin>
        </Col>
        <Col span={1}></Col>
        <Col span={8}>
          <Margin top={5}></Margin>
          <div className="videoDashBorder-vertical" style={{marginTop:"100px"}}>
            <img className="videoStyle-vertical" src={sandoghKhesarat} />
          </div>
          <Margin bottom={5}></Margin>
        </Col>

        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div style={{ backgroundColor: "#fff" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}>
            <p
              style={{
                fontFamily: "IRANSans",
                color: "#ed1c24",
                direction: "rtl",
                textAlign: "right",
                fontSize: "1.05em",
              }}
            >
              <strong>صندوق بیمه حوادث طبیعی ساختمان</strong>
            </p>
          </Margin>
        </Col>
        <Col span={1}></Col>
      </Row>

      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphTablet">
            در راستای ماده ۱ قانون تاسیس صندوق بیمه ساختمان تمام منازل مسکونی
            کشور بالغ بر ۳۲ میلیون انشعاب برق بیمه پایه نزد صندوق هستند که
            خسارتهای مالی ناشی از حوادث طبیعی از جمله زلزله، سیل، طوفان، صاعقه،
            سنگینی برف، رانش زمین، ریزش کوه و دریالرزه (سونامی) به زیاندیده
            هموطنان پرداخت میگردد که در سال اول در دو‌ نوبت، نوبت اول ۲۰ هزار
            ساختمان خسارت دیده ودر نوبت دوم ۴۵ هزار ساختمان توسط ایرانیان پوشش
            در سراسر کشور ارزیابی گردید و بعد از رضایت این دو نوبت خسارت کل کشور
            به این شرکت وفق قرارداد واگذار گردیده است به عبارتی از ابتدا تاسیس
            این صندوق ، ارزیابی از طریق اپلیکیشن کارشناسی و CRM شبانه روزی با
            بهره گیری از گسترده ترین شبکه کارشناسان خبره بیمه های آتش سوزی و
            ساختمان به ايرانيان پوشش در سرتاسر كشور واگذار گرديده است و تاكنون
            به عنوان بازوی امین صندوق حوادث طبیعی ساختمان، در زمینه های مرتبط با
            ارزیابی خسارات ناشی از حوادث طبیعی، نقشی مؤثر و حیاتی را در حمایت از
            زیان دیدگان به منظور صیانت از حقوق آنها ایفا نموده است.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={3}></Col>
        <Col span={18}>
        <div className="videoDashBorder-vertical" style={{marginTop:"100px"}}>
            <img className="videoStyle-vertical" src={sandoghKhesarat} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={3}></Col>
      </Row>
    </div>
  ) : (
    <div style={{ backgroundColor: "#fff" }}>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <Margin top={4}></Margin>

          <p
            style={{
              fontFamily: "IRANSans",
              color: "#ed1c24",
              direction: "rtl",
              textAlign: "right",
              fontSize: ".95em",
              marginTop: "-10px",
            }}
          >
            <strong>
              <strong>صندوق بیمه حوادث طبیعی ساختمان</strong>
            </strong>
          </p>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <p className="textParagraphMobile">
            در راستای ماده ۱ قانون تاسیس صندوق بیمه ساختمان تمام منازل مسکونی
            کشور بالغ بر ۳۲ میلیون انشعاب برق بیمه پایه نزد صندوق هستند که
            خسارتهای مالی ناشی از حوادث طبیعی از جمله زلزله، سیل، طوفان، صاعقه،
            سنگینی برف، رانش زمین، ریزش کوه و دریالرزه (سونامی) به زیاندیده
            هموطنان پرداخت میگردد که در سال اول در دو‌ نوبت، نوبت اول ۲۰ هزار
            ساختمان خسارت دیده ودر نوبت دوم ۴۵ هزار ساختمان توسط ایرانیان پوشش
            در سراسر کشور ارزیابی گردید و بعد از رضایت این دو نوبت خسارت کل کشور
            به این شرکت وفق قرارداد واگذار گردیده است به عبارتی از ابتدا تاسیس
            این صندوق ، ارزیابی از طریق اپلیکیشن کارشناسی و CRM شبانه روزی با
            بهره گیری از گسترده ترین شبکه کارشناسان خبره بیمه های آتش سوزی و
            ساختمان به ايرانيان پوشش در سرتاسر كشور واگذار گرديده است و تاكنون
            به عنوان بازوی امین صندوق حوادث طبیعی ساختمان، در زمینه های مرتبط با
            ارزیابی خسارات ناشی از حوادث طبیعی، نقشی مؤثر و حیاتی را در حمایت از
            زیان دیدگان به منظور صیانت از حقوق آنها ایفا نموده است.
          </p>
        </Col>
        <Col span={2}></Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Margin top={3}></Margin>
          <div className="videoDashBorder-vertical">
            <img className="videoStyle-vertical" src={sandoghKhesarat} />
          </div>
          <Margin bottom={4}></Margin>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  );
};

export default SandoghKhesarat;
